package com.rajen.angrejidictionary.components.layouts

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.rajen.angrejidictionary.analytics.GoogleAnalytics
import com.rajen.angrejidictionary.components.sections.Footer
import com.rajen.angrejidictionary.components.sections.Header
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.ColumnScope
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.data.getValue
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toAttrs
import kotlinx.browser.document
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.dom.Div

val PageContentStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .flex(1)
            .minHeight(0.px)
            .overflow { y(Overflow.Auto); x(Overflow.Hidden) }
            .padding(
                leftRight = 1.cssRem,
                top = 3.cssRem,
                bottom = 1.75.cssRem
            )
            .styleModifier {
                property("scrollbar-width", "none")       // Firefox
                property("-ms-overflow-style", "none")    // legacy Edge/IE
            }
    }

    cssRule("::-webkit-scrollbar") {
        Modifier.styleModifier {
            property("display", "none")                   // Chrome/Safari
        }
    }

    Breakpoint.SM {
        Modifier.padding(leftRight = 1.5.cssRem, top = 3.25.cssRem, bottom = 2.cssRem)
    }

    Breakpoint.MD {
        Modifier
            .maxWidth(100.percent)
            .padding(leftRight = 2.cssRem, top = 3.5.cssRem, bottom = 2.25.cssRem)
    }
}

class PageLayoutData(
    val title: String,
    val description: String = ""
)

private fun canonicalUrlFor(path: String): String {
    val normalized = if (path == "/") "/" else path.trimEnd('/')
    return "https://angrejidictionary.com$normalized"
}

@Composable
@Layout
fun PageLayout(ctx: PageContext, content: @Composable ColumnScope.() -> Unit) {
    val data = ctx.data.getValue<PageLayoutData>()
    LaunchedEffect(data.title, ctx.route.path) {
        document.title = "Angreji Dictionary - ${data.title}"
        document.querySelector("meta[name='description']")
            ?.setAttribute("content", data.description)

        // Canonical must match the *actual* page, not the hardcoded
        // homepage baked into index.html in build.gradle.kts
        document.querySelector("link[rel='canonical']")
            ?.setAttribute("href", canonicalUrlFor(ctx.route.path))
        GoogleAnalytics.pageView(document.title, ctx.route.path)
    }

    // Fixed-height shell pinned to the viewport. Header and Footer take their
    // natural height; the content Div gets the rest via flex(1) and scrolls
    // internally. The outer Column itself never scrolls.
    Column(
        Modifier
            .fillMaxWidth()
            .height(100.vh)
            .overflow { y(Overflow.Hidden); x(Overflow.Hidden) }
            .backgroundColor(Color.rgb(0xFF, 0xEC, 0xDE)),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Header()

        Div(PageContentStyle.toAttrs()) {
            content()
        }

        Footer(Modifier.fillMaxWidth())
    }
}